import { Plan } from '../../domain/plan/Plan';
import { PlanDTO } from '../../domain/plan/PlanDTO';
import { PlanRepositoryDTO } from '../../domain/plan/PlanRepositoryDTO';
import { ProjectCustomFields } from '../../domain/project/ProjectCustomFields';
import { DriverMapper } from '../driver/DriverMapper';
import { GeoFenceMapper } from '../geoFence/GeoFenceMapper';
import { StopMapper } from '../stop/StopMapper';

export class PlanMapper {
  static toDomain(props: PlanDTO, projectCustomFields: ProjectCustomFields): Plan {
    const {
      id,
      organization_id,
      project_id,
      status,
      execution_date,
      label,
      completed_stops,
      canceled_stops,
      pending_stops,
      total_stops,
      total_drivers,
      created_by,
      created_at,
      updated_at,
      deleted_at,
      deleted,
      stops,
      drivers,
      geo_fences,
    } = props;

    return Plan.create(
      {
        organization_id,
        project_id,
        status,
        execution_date,
        label,
        drivers: drivers.map((stop) => DriverMapper.toDomain(stop, projectCustomFields)),
        stops: stops.map((stop) => StopMapper.toDomain(stop, projectCustomFields)),
        geo_fences: geo_fences.map((geo) => GeoFenceMapper.toDomain(geo)),
        completed_stops,
        canceled_stops,
        pending_stops,
        total_stops,
        total_drivers,
        created_by,
        created_at,
        updated_at,
        deleted_at,
        deleted,
      },
      id
    );
  }

  static toRepository(plan: Plan): PlanRepositoryDTO {
    return {
      label: plan.label,
      status: plan.status,
      execution_date: plan.execution_date,
      geo_fences: plan.geo_fences.map((geo) => geo.id),
      drivers: plan.drivers.map((driver) => DriverMapper.toRepository(driver)),
    };
  }

  static toDTO(plan: Plan): PlanDTO {
    return {
      id: plan.id,
      organization_id: plan.organization_id,
      project_id: plan.project_id,
      status: plan.status,
      execution_date: plan.execution_date,
      label: plan.label,
      completed_stops: plan.completed_stops,
      incomplete_stops: plan.incomplete_stops,
      canceled_stops: plan.canceled_stops,
      pending_stops: plan.pending_stops,
      total_stops: plan.total_stops,
      total_drivers: plan.total_drivers,
      created_at: plan.created_at,
      created_by: plan.created_by,
      updated_at: plan.updated_at,
      deleted_at: plan.deleted_at,
      deleted: plan.deleted,
      stops: plan.stops.map(StopMapper.toDTO),
      drivers: plan.drivers.map(DriverMapper.toDTO),
      geo_fences: plan.geo_fences.map(GeoFenceMapper.toDTO),
    };
  }
}
